import { render, staticRenderFns } from "./ExcelUploadResult.vue?vue&type=template&id=2f9ab8b1"
import script from "./ExcelUploadResult.vue?vue&type=script&lang=js"
export * from "./ExcelUploadResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports